import { AlertTriangle, Mail, X } from 'lucide-react';
import { useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';

export function ProfileCompletionBanner() {
  const { user, isAuthenticated } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  // Don't show if not authenticated, profile is complete, or banner was dismissed
  if (!isAuthenticated || !user || user.profile_complete || dismissed) {
    return null;
  }

  // Don't show for admin users - they manage their own access
  if (user.roles.includes('admin')) {
    return null;
  }

  // Determine what's missing
  const missingCompany = !user.company_id;
  const isNewMeddSimUser = user.medd_sim_user && missingCompany;

  // If everything is fine, don't show banner
  if (!missingCompany) {
    return null;
  }

  return (
    <div className="bg-amber-50 dark:bg-amber-950/30 border-b border-amber-200 dark:border-amber-800">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="flex-shrink-0">
              <AlertTriangle className="h-5 w-5 text-amber-600 dark:text-amber-500" />
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium text-amber-800 dark:text-amber-200">
                {isNewMeddSimUser ? (
                  <>
                    Welcome to MEDD Simulation Platform! Your profile is incomplete.
                  </>
                ) : (
                  <>
                    Your profile needs attention to access all features.
                  </>
                )}
              </p>
              <p className="text-sm text-amber-700 dark:text-amber-300 mt-0.5">
                {missingCompany && (
                  <>Your company hasn't been assigned yet. Please contact your administrator or MEDD support to complete your setup.</>
                )}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              className="border-amber-300 dark:border-amber-700 text-amber-800 dark:text-amber-200 hover:bg-amber-100 dark:hover:bg-amber-900/50"
              onClick={() => window.location.href = 'mailto:support@medd.com.au?subject=Company%20Assignment%20Request'}
            >
              <Mail className="h-4 w-4 mr-1.5" />
              Contact Support
            </Button>
            <button
              onClick={() => setDismissed(true)}
              className="p-1 rounded-md text-amber-600 dark:text-amber-400 hover:bg-amber-100 dark:hover:bg-amber-900/50 transition-colors"
              aria-label="Dismiss"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
